export const ASSISTANCE_TYPE = {
    full_time: {
        en: 'Taking my business from part time to full time',
        es: 'Llevando mi negocio de medio tiempo a tiempo completo'
    },
    hiring: {
        en: 'Hiring my first paid worker',
        es: 'Contratando a mi primer trabajador con sueldo'
    },
    grow: {
        en: 'Growing my business revenues or staff size',
        es: 'Aumentando los ingresos o el personal de mi negocio'
    },
    f_problem: {
        en: 'Resolve an urgent or upcoming financial problem',
        es: 'Resolver un problema financiero urgente o futuro'
    },
    nf_problem: {
        en: 'Resolve an urgent or upcoming non-financial problem',
        es: 'Resolver un problema urgente o futuro no financiero'
    },
    other: {
        en: 'Other',
        es: 'Otro'
    },
    idk: {
        en: 'Don’t Know',
        es: 'No sé'
    },
    dna: {
        en: 'Prefer Not to Answer',
        es: 'Prefiero no responder'
    }
} as Record<string, { en: string; es: string }>;
